module.exports = "/_next/static/images/CallToAction2-60e1b3eab9121a2861be935dd2719e6f.svg";